import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { endpoint } from '../../resource/Constant';
import { useNavigate } from 'react-router';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { Login } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { Backdrop, Button, CircularProgress, circularProgressClasses } from '@mui/material';

import './login.css';

export default function Sign_Up() {
  document.body.style.backgroundColor = '#e0e0e0';
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [verifyOtp, setVerifyOtp] = useState({ email: '', otp: '' });
  const navigate = useNavigate();
  const { login } = useAuth();
  const { isAuthenticated } = useAuth();
  const [valueObj, setValueObj] = useState({
    company_name: undefined,
    password: undefined,
    email: undefined
  });

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // Toggle confirm password visibility
  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const onSignUp = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(endpoint + `/api/signup?code=GUNADHYAMEMBER@123`, valueObj)
      .then((res) => {
        setOtpSent(true);
        toast.success(`Account created!`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
      })
      .catch((e) => {
        toast.error(`Account not created.`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
      });
  };

  const onVerifyOtpSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const param = { email: verifyOtp.email, otp: verifyOtp.otp };
    axios
      .post(endpoint + `/api/verify-otp`, null, { params: param })
      .then((res) => {
        localStorage.setItem('authToken', res.data.access_token);
        toast.success(`Account Verified!`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
        login();
        navigate('/createinterview');
      })
      .catch((err) => {
        setLoading(false);
        toast.error(`${err?.response?.data?.detail ? err?.response?.data?.detail : 'Invalid Verification.'}`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
      });
  };

  return (
    <div
      style={{
        height: '100vh', // full screen height
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: "'Roboto', sans-serif"
      }}
    >
      <div className="signup-form">
        {!otpSent && (
          <>
            <h2 style={{ color: '#008267', marginBottom: '20px' }}>Sign Up</h2>
            <form onSubmit={onSignUp}>
              {/* Name Input */}
              <div style={{ marginBottom: '20px' }}>
                <input
                  type="text"
                  placeholder="Company Name"
                  className="form-control"
                  value={valueObj.company_name}
                  onChange={(e) => {
                    setValueObj((prev) => ({
                      company_name: e.target.value,
                      password: prev.password,
                      company_email: prev.company_email
                    }));
                  }}
                  style={{
                    height: '50px',
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    marginBottom: '10px',
                    fontSize: '16px'
                  }}
                  id="exampleInputFullName"
                />
              </div>

              {/* Email Input */}
              <div style={{ marginBottom: '20px' }}>
                <input
                  type="email"
                  placeholder="Company Email"
                  className="form-control"
                  value={valueObj.company_email}
                  onChange={(e) => {
                    setValueObj((prev) => ({
                      company_name: prev.company_name,
                      password: prev.password,
                      company_email: e.target.value
                    }));
                  }}
                  style={{
                    height: '50px',
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    marginBottom: '10px',
                    fontSize: '16px'
                  }}
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>

              {/* Password Input with Toggle */}
              <div style={{ marginBottom: '20px', position: 'relative' }}>
                <input
                  type={passwordVisible ? 'text' : 'password'}
                  placeholder="Password"
                  className="form-control"
                  value={valueObj.password}
                  onChange={(e) => {
                    setValueObj((prev) => ({
                      company_name: prev.company_name,
                      password: e.target.value,
                      company_email: prev.company_email
                    }));
                  }}
                  style={{
                    height: '50px',
                    width: '100%',
                    padding: '10px 30px 10px 10px', // Added padding for the icon
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    marginBottom: '10px',
                    fontSize: '16px'
                  }}
                  id="exampleInputPassword1"
                />
                {/* Password Visibility Toggle */}
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: '#6F42C1',
                    fontSize: '16px',
                    cursor: 'pointer'
                  }}
                >
                  {passwordVisible ? (
                    <i style={{ color: '#007e94' }} class="fa-solid fa-eye"></i>
                  ) : (
                    <i style={{ color: '#007e94' }} class="fa-solid fa-eye-slash"></i>
                  )}
                </button>
              </div>

              {/* Submit Button */}
              <div style={{ marginBottom: '20px' }}>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))',
                    border: 'none',
                    color: '#fff',
                    padding: '10px 20px',
                    fontSize: '16px',
                    width: '100%',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s'
                  }}
                  onMouseOver={(e) => (e.target.style.backgroundColor = 'rgb(45 82 126)')}
                  onMouseOut={(e) => (e.target.style.backgroundColor = 'rgb(65 90 119)')}
                >
                  Sign Up
                </button>
              </div>
            </form>
          </>
        )}
        {otpSent && (
          <>
            <h2 style={{ color: '#008267', marginBottom: '20px' }}>Verify OTP</h2>
            <form onSubmit={onVerifyOtpSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <input
                  type="email"
                  required
                  placeholder="Company Email"
                  className="form-control"
                  value={verifyOtp.email}
                  onChange={(e) => {
                    setVerifyOtp((prev) => ({
                      email: e.target.value,
                      otp: prev.otp
                    }));
                  }}
                  style={{
                    height: '50px',
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    marginBottom: '10px',
                    fontSize: '16px'
                  }}
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <input
                  type="number"
                  required
                  placeholder="OTP"
                  className="form-control"
                  value={verifyOtp.otp}
                  onChange={(e) => {
                    setVerifyOtp((prev) => ({
                      email: prev.email,
                      otp: e.target.value
                    }));
                  }}
                  style={{
                    height: '50px',
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    marginBottom: '10px',
                    fontSize: '16px'
                  }}
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))',
                    border: 'none',
                    color: '#fff',
                    padding: '10px 20px',
                    fontSize: '16px',
                    width: '100%',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s'
                  }}
                  onMouseOver={(e) => (e.target.style.backgroundColor = 'rgb(45 82 126)')}
                  onMouseOut={(e) => (e.target.style.backgroundColor = 'rgb(65 90 119)')}
                >
                  Verify
                </button>
              </div>
            </form>
          </>
        )}

        {/* Redirect to Login Link */}
        <div>
          <p style={{ fontSize: '14px' }}>
            Already have an account?{' '}
            <a
              href="/login"
              style={{
                color: '#007e94',
                textDecoration: 'none'
              }}
            >
              Login here
            </a>
          </p>
        </div>
        {!otpSent && (
          <div>
            <p style={{ fontSize: '14px' }}>
              To Verify OTP{' '}
              <Button
                onClick={() => {
                  setOtpSent(true);
                }}
                sx={{
                  color: '#007e94',
                  textDecoration: 'none',
                  p: 0
                }}
              >
                verify-otp
              </Button>
            </p>
          </div>
        )}
      </div>
      <Backdrop open={loading}>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#e01cd5" />
              <stop offset="100%" stopColor="#1CB5E0" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
      </Backdrop>
    </div>
  );
}
